import React from 'react'
import { Flex, styled } from '@fareye/ui'
import { Span } from './styled'
import { ColorSpan, RWDSpan } from '../../style/styled'

export function FieldValue({
  style,
  label,
  value,
  labelStyle,
  valueStyle
}: any) {
  return (
    <Flex
      alignItemsFlexEnd
      style={{
        justifyContent: label ? 'space-between' : 'flex-start',
        ...style
      }}
    >
      {label ? (
        <RWDSpan style={{ color: 'inherit', ...labelStyle }}>
          {label}&nbsp;
        </RWDSpan>
      ) : null}
      {value ? (
        <ColorSpan title={value} style={{ ...valueStyle }}>
          {value}
        </ColorSpan>
      ) : (
        <RWDSpan style={{ color: 'inherit' }}>&nbsp;</RWDSpan>
      )}
    </Flex>
  )
}
